export default function Banner() {
  return (
    <div className="flex justify-center items-center bg-neutral-700 shadow-md p-2 fixed-top z-50 w-full">
      <p className="text-white text-xs font-['Work_Sans'] rounded-md tracking-">
        WELCOME TO THE DIDSBURY WARDROBE...
      </p>
    </div>
  );
}
